export default __webpack_public_path__ + "static/media/feedback.678f1df3.webp";